import type { Components } from '@mui/material'

export const MuiSelect: Components['MuiSelect'] = {
  defaultProps: {
    size: 'small',
    margin: 'dense',
    fullWidth: true,
  },
}
